import * as React from 'react';
import icon from './icon-layers.svg';
import { OverlayIcon } from '../components/OverlayIcon';

export const AddGraphics = () => {
  return (
    <div>
      <OverlayIcon imageUrl={icon} />
      <h3>Add graphics</h3>
      <p>
        Drop your files here or use the{' '}
        <span
          style={{
            color: 'white',
            background: 'var(--accent-color)',
            borderRadius: 4,
            display: 'inline-block',
            width: 22,
            height: 22
          }}
        >
          <span
            style={{
              display: 'inline-block',
              transform: 'translateY(-1.5px)'
            }}
          >
            +
          </span>
        </span>{' '}
        button on the left to add graphic layers.
      </p>
      <p className="footer">
        Supported files: <strong>.jpg</strong>, <strong>.png</strong>,{' '}
        <strong>.gif</strong> and <strong>.mp4</strong>
      </p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/onboarding/AddGraphics.tsx